import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.highRiskSupplements;
export const highRiskSupplementsListSelector = (state: RootState) => getState(state).data;
export const highRiskSupplementsSearchDataSelector = (state: RootState) =>
  getState(state).searchData?.tableData || null;
export const highRiskSupplementsListIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const highRiskSupplementsListErrorSelector = (state: RootState) => getState(state).error;
export const highRiskSupplementsListPaginationSelector = (state: RootState) =>
  getState(state).pagination || { page: 1 };
